import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private http = inject(HttpClient);
  private apiServer = environment.authenticationServer;

  // The exact variables from your legacy service
  private isCache: boolean = false;
  private cachedPolicy: any = null;

  async GetPasswordPolicy(cacheValue?: boolean): Promise<any> {
    if (cacheValue !== undefined && cacheValue !== null) {
      this.isCache = cacheValue;
    }

    if (this.isCache && this.cachedPolicy) {
      return this.cachedPolicy;
    }

    const response = await firstValueFrom(
      this.http.get<any>(`${this.apiServer}/api/password/policy`)
    );

    if (this.isCache) {
      this.cachedPolicy = response;
    }

    return response;
  }

  async UpdatePasswordPolicy(passwordTerms: any): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(`${this.apiServer}/api/password/policy`, passwordTerms)
    );
  }

  async ResetPasswordPolicy(): Promise<any> {
    return firstValueFrom(
      this.http.delete<any>(`${this.apiServer}/api/password/policy/reset`)
    );
  }
}